export default "__VITE_ASSET__8d406002__"